import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Label from '../Label';
import TagInput from './TagInput';
const TagInputField = ({ input, meta, label, labelTooltip, required, disabled, ...props }) => (_jsxs(_Fragment, { children: [label ? (_jsx(Label, { disabled: disabled, required: required, tooltip: labelTooltip, children: label })) : null, _jsx(TagInput, { ...input, error: meta.touched && (meta.error || meta.submitError), disabled: disabled, ...props })] }));
export default TagInputField;
